export default __webpack_public_path__ + "static/media/17.a75dd54b.svg";